import type {CreateMaterialFormPayload} from "./create-material.schema";

import {createMaterial} from "@project/sdk/engineering";
import {mutationOptions} from "@tanstack/react-query";

import {materialKeys, materialMutationKeys} from "../../../material-keys";

export function createMaterialMutationOptions() {
  return mutationOptions({
    mutationKey: materialMutationKeys.createMaterial,
    mutationFn: (payload: CreateMaterialFormPayload) => createMaterial(payload),
    onSuccess: async (_id, _payload, _context, {client}) => {
      await client.invalidateQueries({queryKey: materialKeys.lists()});
    },
  });
}
